(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Avati", [], factory);
	else if(typeof exports === 'object')
		exports["Avati"] = factory();
	else
		root["Avati"] = root["Avati"] || {}, root["Avati"]["core"] = factory();
})(typeof self !== 'undefined' ? self : this, () => {
return 